import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../general/Button";
import config from "../../../config/channels";
import useSiteContext from "../../../contexts/site/useSiteContext";
import {useNavigate} from "react-router-dom";
import TinyModal from "../../general/TinyModal";
import useGroupContext from "../../../contexts/group/useGroupContext";
import { t } from 'ttag';

type LeavingModalProps = {
    show: boolean;
    onHide: () => void;
};

const LeavingModal = ({
    show,
    onHide,
}: LeavingModalProps) => {

    const navigate = useNavigate();
    const siteContext = useSiteContext();
    const groupContext = useGroupContext();
    const isDineIn = siteContext.channel === config.dineIn.name;

    useEffect(() => {
        document.getElementById('leaving-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('leaving-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const renderFooter = () => {
        return (
            <>
                <CTA secondary buddies
                     onClick={() => navigate(`/${isDineIn ? config.dineIn.handle : siteContext.channel}`)}
                >
                    <span>Leave location</span>
                </CTA>
                <CTA buddies
                     onClick={onHide}>
                    <span>Stay here</span>
                </CTA>
            </>
        )
    }

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            modalID={'leaving-modal'}
            header="Leave location?"
            footer={renderFooter()}
        >
            <>
                <p>Leaving this location will empty your basket. Keep ordering from this location?</p>
                { groupContext.active && (
                    <p>{t`Your group order carries on if you only change your postcode. If you choose a different restaurant, it ends for everyone.`}</p>
                )}
            </>
        </TinyModal>
    );
};


export default LeavingModal;
